module.exports = __webpack_public_path__ + "static/media/manta.874c22e7.png";